    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                         @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">

                                                
                                                            <el-form-item label="别名:">
                                    <el-input v-model="table.where.other_alias" placeholder="请输入别名"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="素材名称:">
                                    <el-input v-model="table.where.other_name" placeholder="请输入素材名称"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="素材备注信息:">
                                    <el-input v-model="table.where.other_desc" placeholder="请输入素材备注信息"  clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="素材类型:">
                                    <el-input v-model="table.where.other_type" placeholder="请输入素材类型"  clearable/>
                                </el-form-item>
                                                                                                        
                                                                                                        
                                                            <el-form-item label="默认值，2为默认:">
                                    <el-input-number v-model="table.where.other_status" placeholder="请输入默认值，2为默认" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="其他素材排序:">
                                    <el-input-number v-model="table.where.other_pos" placeholder="请输入其他素材排序" :controls="false" controls-position="right" class="ele-fluid ele-text-left" clearable/>
                                </el-form-item>
                                                                                                        
                                                            <el-form-item label="创建时间:" >
                                    <el-date-picker v-model="table.where.create_time" type="datetimerange" start-placeholder="开始日期"
                                                    end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                                                                                                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                       class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download" class="ele-btn-icon"
                                       v-if="permission.includes('sys:activityturntableskinother:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                               class="ele-btn-icon" size="small" >刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small" v-if="permission.includes('sys:activityturntableskinother:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small" v-if="permission.includes('sys:activityturntableskinother:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                               @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)" highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left"/>
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left" show-overflow-tooltip/>
                                                                                    
                                    <el-table-column prop="other_alias" label="别名" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="other_name" label="素材名称" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="other_desc" label="素材备注信息" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="other_type" label="素材类型" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    <el-table-column prop="other_file" label="素材value" show-overflow-tooltip min-width="250" >
                                    <template slot-scope="{row}">
                                        <a :href="row.other_file" target="_blank"><el-tag>文件</el-tag></a>
                                    </template>
                                </el-table-column>
                                                                                                                
                                    <el-table-column prop="other_status" label="默认值，2为默认" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                                    
                                    <el-table-column prop="other_pos" label="其他素材排序" sortable="custom" show-overflow-tooltip min-width="120"/>
                                                                                                                                            
                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false"  fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" v-if="permission.includes('sys:activityturntableskinother:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此其他素材吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" v-if="permission.includes('sys:activityturntableskinother:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改其他素材':'添加其他素材'" :visible.sync="showEdit"  width="800px" :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                                                                        
                                                                <el-form-item label="别名:" prop="other_alias">
                                    <el-input v-model="editForm.other_alias" placeholder="请输入别名" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="素材名称:" prop="other_name">
                                    <el-input v-model="editForm.other_name" placeholder="请输入素材名称" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="素材备注信息:" prop="other_desc">
                                    <el-input v-model="editForm.other_desc" placeholder="请输入素材备注信息" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="素材类型:" prop="other_type">
                                    <el-input v-model="editForm.other_type" placeholder="请输入素材类型" clearable />
                                </el-form-item>
                                                                                                            
                                
                                <el-form-item label="素材value:" prop="other_file">
                                    <ele-upload-resource-other :limit="1" v-model="editForm.other_file"></ele-upload-resource-other>

                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="默认值，2为默认:" prop="other_status">
                                    <el-input-number v-model="editForm.other_status" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入默认值，2为默认" clearable />
                                </el-form-item>
                                                                                                            
                                                                <el-form-item label="其他素材排序:" prop="other_pos">
                                    <el-input-number v-model="editForm.other_pos" controls-position="right" :controls="false" :precision="0" class="ele-fluid ele-text-left" placeholder="请输入其他素材排序" clearable />
                                </el-form-item>
                                                                                                            
                                                                                                        
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import { mapGetters } from "vuex";

                        import EleUploadResourceOther from '@/components/EleUploadResourceOther'
                                
        export default {
            name: "SysActivityTurntableSkinOther",
            components: {
                                                EleUploadResourceOther,
                                                            },
            data() {
                return {
                                        table: {
                        url: '/activity/ActivityTurntableSkinOther/index',
                        where: {"other_file":[]}                    },  // 表格配置
                    choose: [],  // 表格选中数据
                    showEdit: false,  // 是否显示表单弹窗
                    editForm: {"other_file":[]},  // 表单数据
                    editFormTemp:{"other_file":[]},
                    admin_list:[],
                    user_list:[],
                    search_show:false,
                                    editRules: {  // 表单验证规则
                                                            
                    other_alias: [
                        {required: true, message: '请输入别名', trigger: 'blur'}],
                    
                                        
                    other_name: [
                        {required: true, message: '请输入素材名称', trigger: 'blur'}],
                    
                                        
                    other_desc: [
                        {required: true, message: '请输入素材备注信息', trigger: 'blur'}],
                    
                                        
                    other_type: [
                        {required: true, message: '请输入素材类型', trigger: 'blur'}],
                    
                                        
                    other_file: [
                        {required: true, message: '请上传素材value', trigger: 'blur'}
                    ],
                    
                                        
                    other_status: [
                        {required: true, message: '请输入默认值，2为默认', trigger: 'blur'}],
                    
                                        
                    other_pos: [
                        {required: true, message: '请输入其他素材排序', trigger: 'blur'}],
                    
                                        
                    create_time: [
                        {required: true, message: '请选择创建时间', trigger: 'blur'}
                    ],
                    
                                        
                },
            }
            },
            computed: {
                ...mapGetters(["permission"]),
                            },
            mounted() {

                                                            },
            methods: {

                /**
                 * 关闭
                 */
                closeDialog(){
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/activity/ActivityTurntableSkinOther/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/activity/ActivityTurntableSkinOther/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) {  // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的其他素材吗?', '提示', {type: 'warning'}).then(() => {
                            const loading = this.$loading({lock: true});
                            this.$http.post('/activity/ActivityTurntableSkinOther/delete', {id: ids}).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({type: 'success', message: res.data.msg});
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else {  // 单个删除
                        const loading = this.$loading({lock: true});
                        this.$http.post('/activity/ActivityTurntableSkinOther/delete', {id:row.id}).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({type: 'success', message: res.data.msg});
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                                                /* 导出数据Excel */
                exportExcel() {
                    let ids  = this.choose.map(d => d.id)
                    if(ids.length == 0){
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/activity/ActivityTurntableSkinOther/exportExcel", {id:ids})
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },
                
            
                }
        }
    </script>

    <style scoped>
        .ele-block >>> .el-upload, .ele-block >>> .el-upload-dragger {
            width: 100%;
        }
    </style>
